"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeaturedScreenLightPress = void 0;
var _react = _interopRequireDefault(require("react"));
var FeaturedScreenLightPress = exports.FeaturedScreenLightPress = function FeaturedScreenLightPress() {
  return _react["default"].createElement("svg", {
    width: "102",
    height: "60",
    viewBox: "0 0 102 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("rect", {
    width: "96",
    height: "54",
    transform: "translate(3 3)",
    fill: "#5C617C"
  }), _react["default"].createElement("rect", {
    x: "10",
    y: "10",
    width: "24",
    height: "12",
    rx: "2",
    fill: "white"
  }), _react["default"].createElement("path", {
    d: "M22 16C23.0938 16 24 15.1094 24 14C24 12.9062 23.0938 12 22 12C20.8906 12 20 12.9062 20 14C20 15.1094 20.8906 16 22 16ZM23.3906 16.5H23.125C22.7812 16.6719 22.4062 16.75 22 16.75C21.5938 16.75 21.2031 16.6719 20.8594 16.5H20.5938C19.4375 16.5 18.5 17.4531 18.5 18.6094V19.25C18.5 19.6719 18.8281 20 19.25 20H24.75C25.1562 20 25.5 19.6719 25.5 19.25V18.6094C25.5 17.4531 24.5469 16.5 23.3906 16.5Z",
    fill: "#6E7391"
  }), _react["default"].createElement("rect", {
    x: "10",
    y: "24",
    width: "24",
    height: "12",
    rx: "2",
    fill: "white"
  }), _react["default"].createElement("path", {
    d: "M22 30C23.0938 30 24 29.1094 24 28C24 26.9062 23.0938 26 22 26C20.8906 26 20 26.9062 20 28C20 29.1094 20.8906 30 22 30ZM23.3906 30.5H23.125C22.7812 30.6719 22.4062 30.75 22 30.75C21.5938 30.75 21.2031 30.6719 20.8594 30.5H20.5938C19.4375 30.5 18.5 31.4531 18.5 32.6094V33.25C18.5 33.6719 18.8281 34 19.25 34H24.75C25.1562 34 25.5 33.6719 25.5 33.25V32.6094C25.5 31.4531 24.5469 30.5 23.3906 30.5Z",
    fill: "#6E7391"
  }), _react["default"].createElement("rect", {
    x: "10",
    y: "38",
    width: "24",
    height: "12",
    rx: "2",
    fill: "white"
  }), _react["default"].createElement("path", {
    d: "M22 44C23.0938 44 24 43.1094 24 42C24 40.9062 23.0938 40 22 40C20.8906 40 20 40.9062 20 42C20 43.1094 20.8906 44 22 44ZM23.3906 44.5H23.125C22.7812 44.6719 22.4062 44.75 22 44.75C21.5938 44.75 21.2031 44.6719 20.8594 44.5H20.5938C19.4375 44.5 18.5 45.4531 18.5 46.6094V47.25C18.5 47.6719 18.8281 48 19.25 48H24.75C25.1562 48 25.5 47.6719 25.5 47.25V46.6094C25.5 45.4531 24.5469 44.5 23.3906 44.5Z",
    fill: "#6E7391"
  }), _react["default"].createElement("rect", {
    x: "36",
    y: "10",
    width: "56",
    height: "40",
    rx: "2",
    fill: "white"
  }), _react["default"].createElement("path", {
    d: "M70.375 24.5H57.625C56.9922 24.5 56.5 25.0156 56.5 25.625V33.125C56.5 33.7578 56.9922 34.25 57.625 34.25H63.25V35H59.125C58.9141 35 58.75 35.1875 58.75 35.375V36.125C58.75 36.3359 58.9141 36.5 59.125 36.5H68.875C69.0625 36.5 69.25 36.3359 69.25 36.125V35.375C69.25 35.1875 69.0625 35 68.875 35H64.75V34.25H70.375C70.9844 34.25 71.5 33.7578 71.5 33.125V25.625C71.5 25.0156 70.9844 24.5 70.375 24.5ZM70 32.75H58V26H70V32.75Z",
    fill: "#6E7391"
  }), _react["default"].createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "101",
    height: "59",
    stroke: "#5C617C"
  }));
};